import { createContext } from 'react';
export var PopupScrollableContext = createContext({
    setScrollableContentRef: function (node) {
        /* noop */
    },
});
//# sourceMappingURL=PopupScrollableContext.js.map